import { lazy } from "react";

export const ProjectActivityView = lazy(() => import("./ProjectActivityView"));
